export var BlockedCreatorsFlow;
(function (BlockedCreatorsFlow) {
    BlockedCreatorsFlow["LOAD_BLOCKED_CREATORS"] = "LoadBlockedCreators";
    BlockedCreatorsFlow["LOAD_MORE_BLOCKED_CREATORS"] = "LoadMoreBlockedCreators";
})(BlockedCreatorsFlow || (BlockedCreatorsFlow = {}));
